import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';

// Layout components
import MainLayout from './components/layouts/MainLayout';
import AdminLayout from './components/layouts/AdminLayout';

// Public pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Unauthorized from './pages/Unauthorized';

// User pages
import Dashboard from './pages/Dashboard';
import Channels from './pages/Channels';
import Messages from './pages/Messages';
import Framework from './pages/Framework';
import Plans from './pages/Admin/PlanManagement';
import Payment from './pages/Payment';
import PlanManagement from './pages/Admin/PlanManagement';
import Users from './pages/Admin/Users';
import Earnings from './pages/Admin/Earnings';
import PaymentHistory from './pages/User/PaymentHistory';

// Admin pages
import AdminDashboard from './pages/Admin/Dashboard';
import Frameworks from './pages/Admin/Frameworks';
import ChannelSettings from './pages/Admin/ChannelSettings';
import MCPConfiguration from './pages/Admin/MCPConfiguration';
import OpenAISettings from './pages/Admin/OpenAISettings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected user routes - Regular users only */}
          <Route element={<ProtectedRoute allowAdmin={false} />}>
            <Route element={<MainLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/framework" element={<Framework />} />
              <Route path="/plans" element={<PlanManagement />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/users" element={<Users />} />
              <Route path="/earnings" element={<Earnings />} />
              <Route path="/payment-history" element={<PaymentHistory />} />
            </Route>
          </Route>

          {/* Protected admin routes - Superadmins only */}
          <Route element={<AdminRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/frameworks" element={<Frameworks />} />
              <Route path="/admin/channels" element={<ChannelSettings />} />
              <Route path="/admin/mcp" element={<MCPConfiguration />} />
              <Route path="/admin/openai" element={<OpenAISettings />} />
              <Route path="/admin/plans" element={<PlanManagement />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/earnings" element={<Earnings />} />
            </Route>
          </Route>

          {/* Fallback redirects based on role */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
